import { component } from "picoapp";
import { formatMoney } from "../lib/currency";

export default component((node) => {
  window.addEventListener("price:update", ({ detail }) => {
    const { comparePrice, key } = detail;

    if (node.dataset.key && node.dataset.key !== key) {
      return;
    }

    if (comparePrice) {
      node.innerHTML = formatMoney(
        comparePrice,
        // eslint-disable-next-line no-template-curly-in-string
        "${{ amount_no_trailing_zeroes }}",
        false
      );
    } else {
      node.innerHTML = null;
    }
  });
});
